import { ListItemText, styled } from "@mui/material";
import { COLORS } from "../../../constants/colors";

export const StyledListItemText = styled(ListItemText)`
  color: ${COLORS.TEXT_SECONDARY};
  overflow-x: hidden;
  & > .MuiTypography-root {
    display: flex;
    align-items: center;
    overflow-wrap: normal;
    transition: all 0.5s ease-out;
    white-space: nowrap;
  }
`;
